import React from "react";
import { toast } from "react-hot-toast";
import type { AppMode } from "../hooks/useTranslator";
import { Tooltip } from "../../../components/Tooltip";

interface HeaderModeToggleProps {
  appMode: AppMode;
  recording: boolean;
  modeTraductorLabel: string;
  modeMinutaLabel: string;
  modeAlert: string;
  setAppMode: (mode: AppMode) => void;
}

export const HeaderModeToggle: React.FC<HeaderModeToggleProps> = ({
  appMode,
  recording,
  modeTraductorLabel,
  modeMinutaLabel,
  modeAlert,
  setAppMode,
}) => {
  const handleModeChange = (mode: AppMode) => {
    if (recording) {
      toast.error(modeAlert);
      return;
    }
    setAppMode(mode);
  };

  return (
    <div className="flex gap-[1px] bg-[var(--pill)] border border-[var(--border)] rounded-[9px] p-[2px] flex-shrink-0">
      <Tooltip text="Subtítulos en vivo + minuta al finalizar">
        <button
          onClick={() => handleModeChange("traductor")}
          aria-label={modeTraductorLabel}
          className={`font-sans text-[11.5px] font-[600] px-[11px] py-[4px] rounded-[7px] cursor-pointer transition-all duration-150 whitespace-nowrap relative ${
            appMode === "traductor"
              ? "bg-[var(--accent)] text-white shadow-[0_2px_8px_var(--accent-muted)]"
              : "text-[var(--text-muted)] bg-transparent hover:bg-[var(--surface-hover)] hover:text-[var(--text)]"
          }`}
        >
          {modeTraductorLabel}
        </button>
      </Tooltip>
      <Tooltip text="Minuta al finalizar">
        <button
          onClick={() => handleModeChange("minuta")}
          aria-label={modeMinutaLabel}
          className={`font-sans text-[11.5px] font-[600] px-[11px] py-[4px] rounded-[7px] cursor-pointer transition-all duration-150 whitespace-nowrap relative ${
            appMode === "minuta"
              ? "bg-[var(--accent)] text-white shadow-[0_2px_8px_var(--accent-muted)]"
              : "text-[var(--text-muted)] bg-transparent hover:bg-[var(--surface-hover)] hover:text-[var(--text)]"
          }`}
        >
          {modeMinutaLabel}
        </button>
      </Tooltip>
    </div>
  );
};
